import type { FaireProductEntity } from "../../entity_types/product";

export const p_fq7ka3hdaw: FaireProductEntity = {
  token: "p_fq7ka3hdaw",
  type: "product",
  name: "*Prebook* Slow Rise Mystery Dumplings - Holiday Edition",
  brandToken: "b_acm3c78p2p",
  brandName: "Handee Products (HPC)",
  imageUrl:
    "https://cdn.faire.com/fastly/7bc4d57be1c355954a49b1ed01257aabc1c2d94b54adeafdc0e43d02976aea3d.jpeg",
  galleryImageUrls: [],
  priceDollars: 4.95,
  description:
    "These Christmas Mystery Dumplings will make the perfect stocking\nstuffer thus Holiday season! \nMade from slow rise foam with 6 cute Christmas themed Dumplings to collect\nthese adorable sensory toys are sure to bring fun and laughs to whole\nFamily!\n- Can you find the rare Peppermint Dumpling???",
  tags: [],
  msrpDollars: 9.99,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T04:52:23.210Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
